import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

const CircularProgressWithLabel = (props) => {
  const { value, showValue } = props;

  const getProps = () => {
    if (showValue && typeof value === "number") {
      return {
        variant: "determinate",
        value,
      };
    }
    return {
      variant: "indeterminate",
    };
  };

  return (
    <Box display="flex" justifyContent="center">
      <Box>
        <CircularProgress color="inherit" {...getProps()} />
      </Box>
    </Box>
  );
};

CircularProgressWithLabel.defaultProps = {
  value: 0,
  showValue: true,
};

CircularProgressWithLabel.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showValue: PropTypes.bool,
};

export default CircularProgressWithLabel;
